import yup from "../../../../../utils/yup-extended";

/**
 * The purchase-limit rules, shared by every offering whose Settings step shows the
 * "Set the number of units a customer can purchase in a single transaction" checkbox.
 *
 * The checkbox and the number are two form fields for one API field: `purchaseLimit` is
 * sent only while the box is ticked, so an unticked box has nothing to validate and
 * whatever number the coach typed before unticking is ignored rather than cleared.
 */
export const purchaseLimitValidationSchemaFields = {
  limitUnitsPerTransaction: yup.bool().default(false),
  purchaseLimit: yup
    .number()
    .nullable()
    // An emptied input arrives as "", which `number()` would otherwise cast to NaN and
    // report as a type error before `required` gets to say the useful thing.
    .transform((parsedValue, originalValue) =>
      originalValue === "" || originalValue === null ? null : parsedValue
    )
    .when("limitUnitsPerTransaction", {
      is: (limitUnitsPerTransaction: boolean) => limitUnitsPerTransaction,
      then: (schema) =>
        schema
          .typeError("Must be a number")
          .integer("Must be a whole number")
          .min(1, "Can't be less than 1")
          .required("Purchase limit is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
};
